<script>
import options from './FilterOverlay.options'
export default options
</script>

<template>
  <nav
    class="kb-filter-overlay kb-burger-menu"
    :aria-label="getLabel('filterOverlayAriaLabel')"
  >
    <h2 id="overlaysearchheader" class="kb-burger-menu__title">
      {{ getLabel('filterOverlayOverskrift') }}
    </h2>

    <div class="kb-general-search__input kb-search-overlay__input">
      <input
        type="search"
        aria-labelledby="overlaysearchheader"
        :placeholder="getLabel('searchOverlayPlaceholder')"
        @keydown.enter="closeOverlay"
        @keydown.tab="tabTrap"
        @keyup="termInput"
        v-model="inputText"
        data-order="first"
      />
      <button
        class="kb-general-search__input__button"
        :title="getLabel('filterOverlaySearchButtonTitle')"
      >
        <svg viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="10" cy="10" r="9.5" stroke="#ffffff" />
          <path
            d="M16 10a6 6 0 0 0-6-6M24.768 25.89l-6.718-6.718 2.122-2.122 7.778 7.778-1.82 1.82"
            stroke="#ffffff"
          />
        </svg>
      </button>
    </div>

    <template v-for="(group, groupindex) in facetGroups" :key="groupindex">
      <div
        class="kb-accordion kb-filter-overlay__facet-group"
        aria-live="polite"
      >
        <h3 class="kb-accordion__question kb-filter-overlay__facet-group__name">
          <svg
            viewBox="0 0 705 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M705 1H2a1 1 0 0 0-1 1v9" stroke="#BFBFB7" />
          </svg>
          <button
            :id="`acc-question${groupindex}`"
            :aria-controls="`acc-answer${groupindex}`"
            aria-expanded="true"
            v-on:click="toggleAccordion"
          >
            {{ group.facetGroup }}
            <div
              class="kb-accordion__question__chevron kb-ui-icon kb-ui-icon--ui-chevron-down"
            ></div>
          </button>
        </h3>

        <div
          class="kb-accordion__answer kb-filter-overlay__facet-values kb-accordion__answer--open"
          :id="`acc-answer${groupindex}`"
          role="region"
          :aria-labelledby="`acc-question${groupindex}`"
        >
          <div class="kb-filter-overlay__facet-values__column">
            <template
              v-for="(facet, facetindex) in group.facetValues"
              :key="facetindex"
            >
              <label class="kb-form-element__checkbox">
                <input
                  @change="filterResults(facet)"
                  :checked="facet.selected"
                  type="checkbox"
                  class="kb-form-element__checkbox__input-field"
                />
                <span class="kb-form-element__checkbox__checked-marker">
                  <div class="kb-ui-icon kb-ui-icon--ui-checkmark"></div>
                </span>
                <span class="kb-form-element__label">{{
                  facet.facetName
                }}</span>
              </label>
            </template>
          </div>
        </div>
      </div>
    </template>
    <div class="kb-filter-overlay__button-container">
      <a
        href=""
        @click.prevent="closeOverlay"
        class="kb-button kb-button--full-color-spot"
        data-order="last"
        @keydown.tab="tabTrap"
        >{{ getLabel('filterOverlayCtaLabel', [totalResultCount]) }}</a
      >
    </div>
  </nav>
</template>
